export default __webpack_public_path__ + "static/media/gallery_04.8dd58ef5.jpg";